import { render, staticRenderFns } from "./OutboundMappings.vue?vue&type=template&id=e12a70ac&"
import script from "./OutboundMappings.vue?vue&type=script&lang=ts&"
export * from "./OutboundMappings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports